module.exports = __webpack_public_path__ + "img/question.189689e3.png";